import { ArrowLeftCircle, InfoEmpty, MessageText } from "iconoir-react";
import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import { inject, observer } from "mobx-react";
import PDFViewer from "../../components/PDFViewer/PDFViewer";
import { getExtensionFile, getNameInCapitalize } from "../../utils/common";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { DATE_FORMAT_DEFAULT } from "../../utils/constants";
import { EmptyText, WordBreak } from "../../components/common/CellText";
import FileItem from "../../components/FileItemComponent/FileItem";
import LinkedTask from "../../components/Linked/LinkedTask";
import LinkedWork from "../../components/Linked/LinkedWork";
import PeopleTag from "../../components/PeopleTag";
import date_format from "../../utils/date_format";
import Message from "../../components/common/Message";

const InternalDocumentIncomingDetail = ({ internalDocumentStore }) => {
    const {
        selectedInternalDocumentIncoming,
        internalDocumentCommentList,
        handlerAssignList,
        combinerAssignList,
        followerAssignList,
        getInternalDocumentComment,
    } = internalDocumentStore;
    const {
        authority_issued_id,
        agency_issued,
        date_issued,
        incoming_date,
        incoming_number,
        document_number,
        signer,
        title,
        attachments,
        linkedTask,
        linkedWork,
        end_date,
        start_date,
        document_status,
        created_at,
    } = selectedInternalDocumentIncoming;
    const { documentId } = useParams();
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
    const [attachmentForView, setAttachmentForView] = useState();
    const commentRef = useRef(null)
    const [openMessage,setOpenMessage]=useState(false)

    const isTabletOrMobile = useMediaQuery({
        query: "(max-width: 1299px)",
    });

    useEffect(() => {
        (async () => {
            try {
                await Promise.all([
                    internalDocumentStore.getInternalDocumentIncomingById(
                        documentId
                    ),
                    getInternalDocumentComment(documentId),
                ]);
            } catch (err) {
                navigate("/internal-document/incoming-document");
                console.log(err);
            } finally {
            }
        })();
        return () => {
            internalDocumentStore.clearSelectedInternalDocumentIncoming();
            internalDocumentStore.clearAssignList();
            internalDocumentStore.clearInternalDocumentCommentList();
        };
    }, [documentId]);

    useEffect(() => {
        if (!attachments) return;
        setAttachmentForView(
            attachments.find((file) =>
                ["pdf", "doc", "docx"].includes(getExtensionFile(file.name))
            )
        );
    }, [attachments]);

    const renderAuthorityIssuedList = (authorityIssuedId, agencyIssued) => {
        const authorityList = [];
        if (authorityIssuedId) {
            authorityList.push(authorityIssuedId.name);
        }
        if (agencyIssued && agencyIssued !== authorityIssuedId?.name) {
            authorityList.push(agencyIssued);
        }
        if (authorityIssuedId || agencyIssued) {
            return authorityList.join(", ");
        }
        return <EmptyText>Không có.</EmptyText>;
    };

    // const renderAttachment = useMemo(
    //     () => (
    //         <PDFViewer
    //             fileId={attachmentForView?.id}
    //             customStyleObj={{
    //                 height: isTabletOrMobile ? 500 : 1000,
    //                 width: 200,
    //             }}
    //             fileType={getExtensionFile(attachmentForView?.name)}
    //         />
    //     ),
    //     [attachmentForView]
    // );
    const renderAttachment = useMemo(
        () => (
            <PDFViewer
                fileId={attachmentForView?.id}
                customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
                fileType={getExtensionFile(attachmentForView?.name)}
            />
        ),
        [attachmentForView]
    );
    const handleClickOpenInfo = (e) => {
        e.stopPropagation();
        setOpen(true);
        document.body.style.overflow = "hidden";
    };

    const handleCloseInfo = () => {
        setOpen(false);
        document.body.style.overflow = "auto";
    };

    const executeScroll = () => commentRef.current.scrollIntoView() 

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    return (
        <div className="py-[20px] ">
            <div className={`px-5 }`}>
                <div className="flex items-center  gap-[22px]">
                    <ArrowLeftCircle
                        className="flex-shrink-0"
                        onClick={() => {
                            navigate(-1);
                        }}
                    />
                    <span className="font-bold text-[28px] leading-[29px] text-[#28353B]">
                        {title}
                    </span>
                </div>
                <div className="flex justify-between">
                    <div
                        className="flex justify-center gap-x-2 items-center mt-5 bg-[rgba(0,115,199,0.07);] py-[10px] w-[calc(50%-10px)] text-primary px-[14px] rounded-full text-sm leading-5 cursor-pointer font-medium"
                        onClick={handleClickOpenInfo}
                    >
                        <div>
                            <InfoEmpty />
                        </div>
                        <span onClick={handleClickOpenInfo}>
                            Thông tin
                        </span>
                    </div>
                    <div className="flex justify-center gap-x-2  items-center mt-5 bg-[rgba(22,25,44,0.07)] py-[10px] w-[calc(50%-10px)]  px-[14px] rounded-full text-sm leading-5 font-medium" onClick={()=>(internalDocumentCommentList?.length>0 ? executeScroll():setOpenMessage(true))}>
                        <div>
                            <MessageText />
                        </div>
                        <span>Ý kiến</span>
                    </div>
                </div>
                <div className="!w-[100%] mt-[14px] ">{renderAttachment}</div>
                <div ref={commentRef}>
                    {internalDocumentCommentList.map((comment) => (
                        <div className="px-[14px]  mt-[14px] py-5 bg-lightBlue rounded ">
                            <div className="flex justify-between items-center mb-[14px]">
                                <div className="text-xs font-semibold leading-5 text-primaryText">
                                    {" "}
                                    {getNameInCapitalize(comment.name_uppercase)}
                                </div>
                                <div className="text-lightText text-[8px] font-medium">
                                    {date_format.renderTime(comment.created_at)}
                                </div>
                            </div>
                            <div className="text-sm font-normal leading-6">
                                {comment.content.trim()}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Dialog
                open={open}
                onClose={handleCloseInfo}
                scroll={"paper"}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                className="doc-popup"
                fullWidth
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100vw",
                            maxWidth: "100vw", // Set your width here
                            mx: 0,
                        },
                    },
                }}
            >
                <DialogTitle
                    id="scroll-dialog-title"
                    className="text-xl font-bold text-[#23374D] !py-9"
                    sx={{
                        fontWeight: 700,
                    }}
                >
                    <span className="font-bold">Thông tin</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        className=""
                    >
                        <table
                            style={{ color: "#16192C" }}
                            className="doc-table-vertical font-semibold text-sm leading-5 text-[#16192C]"
                        >
                            <tr>
                                <th style={{ paddingBottom: 14 }}>Số hiệu:</th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {document_number}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>Số đến:</th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {incoming_number}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    Ngày văn bản:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {date_issued ? (
                                        <>
                                            <span>
                                                {moment(date_issued).format(
                                                    DATE_FORMAT_DEFAULT
                                                )}
                                            </span>
                                        </>
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    Ngày đến:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {incoming_date ? (
                                        <>
                                            <span>
                                                {moment(incoming_date).format(
                                                    DATE_FORMAT_DEFAULT
                                                )}
                                            </span>
                                        </>
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    Người ký:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {signer ? (
                                        signer
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    CQ ban hành:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {WordBreak(
                                        renderAuthorityIssuedList(
                                            authority_issued_id,
                                            agency_issued
                                        )
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    Tài liệu đính kèm:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    {attachments ? (
                                        attachments.map((file) => (
                                            <FileItem
                                                file={file}
                                                key={file.id}
                                                file_id={file.id}
                                                file_name={file.name}
                                                file_type={getExtensionFile(
                                                    file.name
                                                )}
                                            />
                                        ))
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    Liên kết nhiệm vụ:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    <LinkedTask linkedTaskList={linkedTask} />
                                </td>
                            </tr>
                            <tr>
                                <th style={{ paddingBottom: 14 }}>
                                    Liên kết công việc:{" "}
                                </th>
                                <td
                                    className="font-normal"
                                    style={{ paddingBottom: 14 }}
                                >
                                    <LinkedWork linkedWorkList={linkedWork} />
                                </td>
                            </tr>
                        </table>
                        <div className="font-semibold text-sm leading-5 text-[#16192C]">
                            <div style={{ paddingBottom: 14 }}>
                                <div>Lãnh đạo xử lý:</div>
                                <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                                    {handlerAssignList.length !== 0 ? (
                                        handlerAssignList.map((item) => (
                                            <PeopleTag el={item} />
                                        ))
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </div>
                            </div>
                            <div style={{ paddingBottom: 14 }}>
                                <div className="table-title">Người xử lý:</div>
                                <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                                    {combinerAssignList.length !== 0 ? (
                                        combinerAssignList.map((item) => (
                                            <PeopleTag el={item} />
                                        ))
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </div>
                            </div>
                            <div style={{ paddingBottom: 14 }}>
                                <div className="table-title">
                                    Phối hợp/theo dõi:
                                </div>
                                <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                                    {followerAssignList.length !== 0 ? (
                                        followerAssignList.map((item) => (
                                            <PeopleTag el={item} />
                                        ))
                                    ) : (
                                        <EmptyText>
                                            Không có.
                                        </EmptyText>
                                    )}
                                </div>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button
                        sx={{ fontWeight: 600 }}
                        onClick={handleCloseInfo}
                        className="pb-6 text-sm font-semibold leading-5 text-primary"
                    >
                        Đóng
                    </Button>
                </DialogActions>
            </Dialog>
            <Message message='Chưa có ý kiến' openMessage={openMessage} closeMessage={() => {
                    setOpenMessage(false);
                }} />
        </div>
    );
};

export default memo(
    inject("internalDocumentStore")(observer(InternalDocumentIncomingDetail))
);
